import { render, staticRenderFns } from "./PaoDisplay.vue?vue&type=template&id=2c7983de&scoped=true"
import script from "./PaoDisplay.vue?vue&type=script&lang=js"
export * from "./PaoDisplay.vue?vue&type=script&lang=js"
import style0 from "./PaoDisplay.vue?vue&type=style&index=0&id=2c7983de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7983de",
  null
  
)

export default component.exports